import { useEffect } from "react";
import { scrollTargetIntoView } from "../../../../../common-deprecated/utils";
import { postalPublish } from "../../../../../common-deprecated/utils/postalUtils";
import { type BuildAndBuyDispatchType, useBnbSelector } from "../../redux/store";
import { startConfigSave } from "../../redux/actions/SaveActions";
import { isLexus } from "../../../../../common-deprecated/settings/utils/commonSettingUtils";
import { POSTAL_CHANNEL_T1_CARCONFIG, POSTAL_TOPIC_BUY_DISPLAYED } from "../../../../../common-deprecated/constants";
import { useDispatch } from "../../../../../shared-logic/redux/store";

// This hook is used to initialize the buy or reserve step
const useInitBuyOrReserve = (reserve?: boolean): void => {
    const save = useBnbSelector((state) => state.save);
    const domTarget = useBnbSelector((state) => state.utils.domTarget);
    const commonSettings = useBnbSelector((state) => state.commonSettings);
    const dispatch = useDispatch<BuildAndBuyDispatchType>();

    useEffect(() => {
        // Make sure the page is scrolled to the top.
        // TODO Make this default behavior if we ever expand single page app behavior.
        scrollTargetIntoView(`#${domTarget}`, true);

        // For Lexus we need to dispatch an event to let the site know that buy has been navigated to
        if (isLexus(commonSettings)) {
            postalPublish({
                channel: POSTAL_CHANNEL_T1_CARCONFIG,
                topic: POSTAL_TOPIC_BUY_DISPLAYED,
                data: reserve ? { type: "reserve" } : undefined,
            });
        }
        // If the config is not saved yet save it. Needed for GFI checkoutflow and summeryModal.
        if (!save.saved && !save.saving) {
            dispatch(startConfigSave());
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
};

export default useInitBuyOrReserve;
